import * as React from 'react';
import FadeIn from '@/components/FadeIn/FadeIn';
import MapPinIcon from '@/assets/icons/MapPinIcon';
import DirectionSignIcon from '@/assets/icons/DirectionSignIcon';

const Location: React.FC = () => (
  <section className='bg-white pt-16 md:pt-24'>
    <div className='container mx-auto px-4 md:px-8 xl:px-25'>
      <FadeIn variant='down' delay={0.2}>
        <h2 className='text-4xl md:text-[44px] font-medium mb-10 text-center'>Location</h2>
      </FadeIn>
      <div className='flex flex-col md:flex-row gap-7 justify-center items-stretch'>
        <FadeIn
          variant='left'
          delay={0.3}
          className='text-white rounded-2xl p-8 w-full flex flex-col items-start mb-6 md:mb-0 h-[526px] bg-no-repeat bg-cover'
          style={{
            backgroundImage:
              'linear-gradient(rgba(5, 34, 108, 0.8) 10%, rgba(80, 213, 162, 0.8) 100%), url(/images/about/about-location-bg.png)',
          }}
        >
          <div className='flex gap-6'>
            <MapPinIcon width={48} height={48} />
            <div className='mb-4 font-medium text-[24px]'>
              5830 Granite Pkwy STE 100/242,
              <br />
              Plano, TX 75024
            </div>
          </div>
        </FadeIn>
        <FadeIn
          variant='right'
          delay={0.4}
          className='w-full max-w-md flex justify-between flex-col pb-5'
        >
          <div className='text-[24px] leading-[34px] text-black/60'>
            With our people spread across diverse timezones and areas, our marketbetter sites offer
            an opportunity for people to socialize and get work done from anywhere!
          </div>
          <a
            href='#'
            target='_blank'
            rel='noopener noreferrer'
            className='text-blue-500 text-[24px] mt-2 font-medium flex gap-2 items-center'
          >
            Get directions
            <DirectionSignIcon />
          </a>
        </FadeIn>
      </div>
    </div>
  </section>
);

export default Location;
